export function goToSearchUrl(query) {
    window.location = `${window.BASE_URL}blog/search?q=${query}`;
}
